module.exports = __webpack_public_path__ + "img/shirley.fb5770fe.png";